<template>
  <div class="gallery-action-mobile-view">
    <mobile-topbar :text="topbarHeaderText" :header-text-from-textkey="false" @leftIconClicked="onReturnClicked" />
    <AulaButtons class="gallery-action-navbar">
      <AulaButton
        variant="link"
        class="action-button"
        :disabled="isDownloading"
        :aria-label="$t('button.download')"
        @click="onDownloadAlbumClicked"
      >
        <Icon :name="iconClassEnum.DOWNLOAD" />
        {{ $t('button.download') }}
        <AulaSpinner v-if="isDownloading" class="action-spinner" />
      </AulaButton>
      <AulaButton
        variant="link"
        class="action-button"
        :disabled="isDeleting || !canDelete"
        :aria-label="$t('button.delete')"
        @click="onDeleteAlbumClicked"
      >
        <Icon :name="iconClassEnum.BIN" />
        {{ $t('button.delete') }}
      </AulaButton>
    </AulaButtons>
    <AlbumList :album-list="selectedAlbums" />
  </div>
</template>

<script>
import MobileTopbar from '../../../shared/components/MobileTopbar.vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Button from '../../../shared/directives/button';
import AulaButtons from '../../../shared/components/AulaButtons.vue';
import AulaButton from '../../../shared/components/AulaButton.vue';
import AlbumList from '../../../shared/PageFragments/Album/AlbumList.vue';

export default {
  name: 'GalleryManagementMobile',
  directives: {
    Button,
  },
  components: { AlbumList, AulaButton, AulaButtons, Icon, MobileTopbar },
  props: {
    selectedAlbums: { type: Array, default: () => [] },
    topbarHeaderText: { type: String, default: '' },
    isDownloading: { type: Boolean, default: false },
    isDeleting: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
  emits: ['onDownloadAlbum', 'onDeleteAlbum', 'onReturn'],
  data() {
    return {
      iconClassEnum,
    };
  },
  methods: {
    onDownloadAlbumClicked() {
      this.$emit('onDownloadAlbum');
    },
    onDeleteAlbumClicked() {
      this.$emit('onDeleteAlbum');
    },
    onReturnClicked() {
      this.$emit('onReturn');
    },
  },
};
</script>

<style scoped lang="scss">
.gallery-action-mobile-view {
  position: fixed;

  .gallery-action-navbar {
    padding: 10px 20px;
    border-bottom: 1px solid var(--color-grey-dunkel);
  }

  ::v-deep .mobile-topbar-container .mid-column {
    font-size: 16px;
    font-weight: bold;
  }
}

.action-button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 5px;
  margin: 0 5px;

  .action-spinner {
    position: absolute;
    right: -40px;
    width: 50px;
    height: 50px;
  }
}
</style>
